module.exports = __webpack_public_path__ + "img/USA_FERMENTED_MILK.72d89a46.png";